<template>
  <v-container fluid pa-0 ma-0 class="user-select-none" fill-height>
    <v-layout row wrap class="ma-0" fill-height>

      <v-toolbar class="pa-0 ma-0 custom-toolbar"
                 color="white" fixed height="56px" flat scroll-off-screen extension-height="48px">
        <v-layout row align-center style="height: 56px; width: 100%;" class="px-1 toolbar-shadow">
          <v-btn icon @click="$router.go(-1)" class="pa-0">
            <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
          </v-btn>
          <h3 class="display-2" style="margin-bottom: 2px">지금 시작하기</h3>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="$router.push({ name: 'SearchProducts' })">
            <v-icon color="#a9a9af" size="32px">$vuetify.icons.search</v-icon>
          </v-btn>
        </v-layout>

        <template v-slot:extension>
          <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory @change="onChangeTab" height="46px">
            <v-tab :ripple="false" v-for="tab of storeCategories" :key="tab.idx" :href="`#tab-${tab.idx}`" class="tab">
              <span>{{ tab.name }}</span>
            </v-tab>
            <v-tabs-slider color="#4a4a4a" class="mx-2" style="width: auto; height: 3px; border-top-left-radius: 24px; border-top-right-radius: 24px;"></v-tabs-slider>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-flex xs12 class="pa-0" style="margin-top: 104px;">
        <v-tabs-items v-model="activeTab"
                      class="fixed-tabs-container pa-0"
                      :touchless="isSlide"
                      @change="onChangeTab">
          <v-tab-item v-for="(tab, index) of storeCategories" :key="index" :value="`tab-${tab.idx}`" :lazy="tab.idx !== 0">
            <Products :nationIdx="tab.idx"
                      :activeTab="activeTab" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Products from '@/views/StoreTabs/Products';

  export default {
    name: 'Store',
    components: { Products },
    computed: {
      ...mapGetters([ 'storeCategories' ]),
    },
    data () {
      return {
        scrollY: 0,
        isSlide: false,
        activeTab: 'tab-0',
      };
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.storeCategories.length === 1) vm.selectStoreCategories();
      });
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
      this.$eventBus.$on('touchCancel', (flag) => {
        this.isSlide = flag;
      });
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      ...mapActions([ 'selectStoreCategories' ]),
      onChangeTab () {
        // this.$eventBus.$emit('tabChanged');
        this.scrollToTop();
      },
      scrollToTop () {
        window.scrollTo(0, 0);
      },
      getScrollY () {
        this.scrollY = window.scrollY;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.custom-toolbar {
    .v-toolbar__content {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .v-toolbar__extension {
      padding: 0;
    }
  }

  .toolbar-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.tab > a {
    padding-left: 0;
    padding-right: 0;
    width: 80px;

    font-size: 16px;
    letter-spacing: -0.53px;
    font-weight: 700;
    color: #4a4a4a;
    /*opacity: 1;*/
  }

  .user-select-none {
    user-select: none;
  }

</style>
